import { render } from "./grid-lists.vue?vue&type=template&id=b30e2436"
import script from "./grid-lists.vue?vue&type=script&lang=js"
export * from "./grid-lists.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__